export const SERVICE_STATES = [
  { code: "PA", name: "Pennsylvania" },
  { code: "NJ", name: "New Jersey" },
  { code: "AL", name: "Alabama" },
  { code: "TX", name: "Texas" },
  { code: "NC", name: "North Carolina" },
  { code: "SC", name: "South Carolina" },
  { code: "GA", name: "Georgia" },
];

export const CONDITION_OPTIONS = [
  "Move-in ready",
  "Needs light work",
  "Needs major repairs",
  "Tear-down / distressed",
  "Not sure",
];

export const TIMELINE_OPTIONS = [
  "ASAP (within 3 weeks)",
  "1-2 months",
  "3-6 months",
  "Just exploring",
];
